import { Plus, Trash2 } from "lucide-react";
import ResumeSection from "@/components/resume/ResumeSection";

const EMPTY_EDUCATION = {
  institution: "",
  degree: "",
  field: "",
  start_date: "",
  end_date: "",
  details: "",
};

function educationKey(edu, idx) {
  return `edu-${idx}-${(edu.institution || "").slice(0, 24)}-${(edu.degree || "").slice(0, 24)}`;
}

function EducationEditCard({ edu, onChange, onRemove }) {
  const update = (patch) => onChange({ ...edu, ...patch });
  return (
    <div className="space-y-2 p-3 border border-dashed border-[var(--border-default)]">
      <div className="grid grid-cols-2 gap-2">
        <input
          placeholder="Degree"
          value={edu.degree || ""}
          onChange={(e) => update({ degree: e.target.value })}
          className="swiss-input !p-2"
        />
        <input
          placeholder="Field"
          value={edu.field || ""}
          onChange={(e) => update({ field: e.target.value })}
          className="swiss-input !p-2"
        />
        <input
          placeholder="Institution"
          value={edu.institution || ""}
          onChange={(e) => update({ institution: e.target.value })}
          className="swiss-input !p-2 col-span-2"
        />
        <input
          placeholder="Start"
          value={edu.start_date || ""}
          onChange={(e) => update({ start_date: e.target.value })}
          className="swiss-input !p-2"
        />
        <input
          placeholder="End"
          value={edu.end_date || ""}
          onChange={(e) => update({ end_date: e.target.value })}
          className="swiss-input !p-2"
        />
        <input
          placeholder="Details"
          value={edu.details || ""}
          onChange={(e) => update({ details: e.target.value })}
          className="swiss-input !p-2 col-span-2"
        />
      </div>
      <button
        type="button"
        onClick={onRemove}
        className="btn-ghost text-[var(--brand-accent)]"
      >
        <Trash2 className="w-3.5 h-3.5" /> REMOVE
      </button>
    </div>
  );
}

function EducationViewItem({ edu }) {
  const head = [edu.degree, edu.field].filter(Boolean).join(", ");
  const dateRange = [edu.start_date, edu.end_date].filter(Boolean).join(" – ");
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <div>
        <div className="font-heading font-bold text-base">{head}</div>
        <div className="text-sm text-[var(--text-secondary)]">
          {edu.institution}
          {edu.details ? ` · ${edu.details}` : ""}
        </div>
      </div>
      <div className="font-mono text-xs text-[var(--text-secondary)] uppercase tracking-wider">
        {dateRange}
      </div>
    </div>
  );
}

export default function EducationSection({
  education = [],
  editing,
  onAdd,
  onUpdate,
  onRemove,
}) {
  return (
    <ResumeSection
      title="Education"
      index={4}
      action={
        editing && (
          <button
            type="button"
            onClick={() => onAdd(EMPTY_EDUCATION)}
            className="btn-ghost"
            data-testid="add-education-button"
          >
            <Plus className="w-3.5 h-3.5" /> ADD
          </button>
        )
      }
    >
      <div className="space-y-4">
        {education.map((edu, idx) => (
          <div
            key={educationKey(edu, idx)}
            data-testid={`education-item-${idx}`}
          >
            {editing ? (
              <EducationEditCard
                edu={edu}
                onChange={(next) => onUpdate(idx, next)}
                onRemove={() => onRemove(idx)}
              />
            ) : (
              <EducationViewItem edu={edu} />
            )}
          </div>
        ))}
      </div>
    </ResumeSection>
  );
}
